export function toCsvValue( val: unknown ): string {
  if ( val === null || val === undefined ) return '';
  const str = typeof val === 'object' ? JSON.stringify( val ) : String( val );
  // Escape quotes and wrap in quotes if contains comma, quote, or newline
  if ( str.includes( ',' ) || str.includes( '"' ) || str.includes( '\n' ) ) {
    return `"${ str.replace( /"/g, '""' ) }"`;
  }
  return str;
}

export function buildCsv( columns: string[], rows: Record<string, unknown>[] ): string {
  const header = columns.map( toCsvValue ).join( ',' );
  const body = rows.map( row => columns.map( col => toCsvValue( row[col] ) ).join( ',' )
  );
  return [ header, ...body ].join( '\n' );
}
